export default {
  'common.save': 'Simpan',
  'common.cancel': 'Batal',
  'common.delete': 'Padam',
  'common.edit': 'Sunting',
  'common.confirm': 'Sahkan',
  'common.close': 'Tutup',
  'common.search': 'Cari',
  'common.loading': 'Memuatkan...',
  'common.processing': 'Memproses...',
  'common.submit': 'Hantar',
  'common.back': 'Kembali',
  'common.next': 'Seterusnya',
  'common.previous': 'Sebelumnya',
  'common.upload': 'Muat naik',
  'common.download': 'Muat turun',
  'common.downloadAll': 'Muat turun semua',
  'common.refresh': 'Muat semula',
  'common.retry': 'Cuba lagi',
  'common.copy': 'Salin',
  'common.copied': 'Disalin',
  'common.selectAll': 'Pilih semua',
  'common.clear': 'Kosongkan',
  'common.clearAll': 'Kosongkan semua',
  'common.apply': 'Guna',
  'common.reset': 'Set semula',
  'common.filter': 'Tapis',
  'common.sort': 'Isih',
  'common.export': 'Eksport',
  'common.import': 'Import',
  'common.preview': 'Pratonton',
  'common.view': 'Lihat',
  'common.add': 'Tambah',
  'common.remove': 'Buang',
  'common.rename': 'Namakan semula',
  'common.share': 'Kongsi',
  'common.settings': 'Tetapan',
  'common.logout': 'Log keluar',
  'common.profile': 'Profil',
  'common.yes': 'Ya',
  'common.no': 'Tidak',
  'common.ok': 'OK',
  'common.areYouSure': 'Adakah anda pasti?',
  'common.actionCannotBeUndone': 'Tindakan ini tidak boleh dibatalkan.',
  'common.noData': 'Tiada data',
  'common.noResultsFound': 'Tiada keputusan ditemui',
  'common.somethingWentWrong': 'Sesuatu tidak kena',
  'common.pleaseTryAgain': 'Sila cuba lagi',
  'common.success': 'Berjaya',
  'common.error': 'Ralat',
  'common.warning': 'Amaran',
  'common.info': 'Maklumat',
  'common.optional': 'Pilihan',
  'common.required': 'Diperlukan',
  'common.name': 'Nama',
  'common.title': 'Tajuk',
  'common.description': 'Penerangan',
  'common.status': 'Status',
  'common.actions': 'Tindakan',
  'common.date': 'Tarikh',
  'common.time': 'Masa',
  'common.createdAt': 'Dicipta',
  'common.updatedAt': 'Dikemas kini',
  'common.type': 'Jenis',
  'common.size': 'Saiz',
  'common.file': 'Fail',
  'common.folder': 'Folder',
  'common.files': 'Fail',
  'common.folders': 'Folder',
  'common.all': 'Semua',
  'common.none': 'Tiada',
  'common.send': 'Hantar',
  'common.sending': 'Menghantar...',
  'common.new': 'Baharu',
  'common.create': 'Cipta',
  'common.duplicate': 'Salin',
  'common.move': 'Alih',
  'common.moveTo': 'Alih ke',
  'common.selectFile': 'Pilih fail',
  'common.chooseFile': 'Pilih fail',
  'common.dragDropFilesHere': 'Seret dan lepaskan fail di sini',
  'common.or': 'atau',
  'common.browse': 'Semak imbas',
  'common.continue': 'Teruskan',
  'common.skip': 'Langkau',
  'common.done': 'Selesai',
  'common.finish': 'Tamat',
  'common.start': 'Mula',
  'common.stop': 'Henti',
  'common.pause': 'Jeda',
  'common.resume': 'Sambung semula',
  'common.enabled': 'Didayakan',
  'common.disabled': 'Dilumpuhkan',
  'common.active': 'Aktif',
  'common.inactive': 'Tidak aktif',
  'common.draft': 'Draf',
  'common.published': 'Diterbitkan',
  'common.archive': 'Arkib',
  'common.unarchive': 'Nyaharkib',
  'common.favourite': 'Kegemaran',
  'common.favourites': 'Kegemaran',
  'common.pin': 'Sematkan',
  'common.unpin': 'Nyahsemat',
  'common.expand': 'Kembangkan',
  'common.collapse': 'Kuncupkan',
  'common.showMore': 'Tunjuk lagi',
  'common.showLess': 'Tunjuk kurang',
  'common.language': 'Bahasa',
  'common.darkMode': 'Mod gelap',
  'common.lightMode': 'Mod cerah',
  'common.help': 'Bantuan',
  'common.feedback': 'Maklum balas',
  'common.notifications': 'Pemberitahuan',
  'common.rows': 'Baris',
  'common.column': 'Lajur',
  'common.total': 'Jumlah',
  'common.page': 'Halaman',
  'common.of': 'daripada',
  'common.notes': 'Nota',
};
